export const AUTH_PANEL_BLUE = '#43c6f8';
export const AUTH_LINK_BLUE = '#0063ff';
export const AUTH_BUTTON_TEXT = '#f8f9fc';
export const AUTH_TAGLINE_WHITE = '#fbfbfd';
export const LOGIN_CONTENT_MAX_WIDTH = '474px';
export const LOGIN_HERO_IMAGE = '/assets/images/auth/login-hero.png';
export const LOGIN_LOGO_IMAGE = '/assets/images/auth/lyt-logo-dark.png';

export const AUTH_PANEL_WIDTH_PX = 413;
/** Narrow hero strip on phones — keeps image, logo, and tagline visible beside the form. */
export const AUTH_PANEL_MOBILE_WIDTH_PX = 132;

/** Viewports at or below this width use the compact hero strip layout. */
export const AUTH_STACKED_LAYOUT_MAX_WIDTH_PX = 767;
